export default __webpack_public_path__ + "static/media/avatar.718192e4.png";